import { useCallback, useEffect, useState } from "react";
import http from "../../../../http";
import { useRecarregaAoRenovarToken } from "../../../shared/hooks/useRecarregaAoRenovarToken";

export const useBuscaAdministradoresDesativados = () => {
    const [listaAdministradoresDesativados, setListaAdministradoresDesativados] = useState([])

    const buscaAdministradoresDesativados = useCallback(() => {
        http.get(`/administradores-desativados`)
            .then(res => {
                const resposta = res.data
                setListaAdministradoresDesativados(resposta)
            })
            .catch(() => setListaAdministradoresDesativados([]))
    }, [])

    useEffect(() => {
        buscaAdministradoresDesativados()
    }, [buscaAdministradoresDesativados])

    useRecarregaAoRenovarToken(buscaAdministradoresDesativados)

    return {
        listaAdministradoresDesativados,
    }
}
